import firebase from "firebase";
import { db } from "./firebase";
import { fetchWorkerSnapshot } from "./workerInfo";

const REGISTRATIONS = "registrations";
const LOCATIONS = "locations";

export const saveRegistrationForm = (data, info) => {
  return new Promise((resolve, reject) => {
    db.collection(REGISTRATIONS)
      .add({
        ...data,
        ...info,
        created: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const getDistricts = () => {
  return new Promise((resolve, reject) => {
    db.collection(LOCATIONS)
      .get()
      .then((snapshot) => {
        let data = [];
        if (!snapshot.empty) {
          data = snapshot.docs;
        }
        resolve(data);
      })
      .catch((e) => reject(e));
  });
};

/**
 * Resolve worker display name via HMAC workerInfo (no direct workers/{id} get).
 */
export const getUserName = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await fetchWorkerSnapshot(id);
      const emp = snapshot.exists ? snapshot.data() : null;
      let data;
      if (emp && (emp.firstName || emp.lastName)) {
        data =
          emp.firstName + " " + (emp.lastName ? emp.lastName : "");
      }
      resolve(data);
    } catch (e) {
      reject(e);
    }
  });
};
